import { Location } from '@app/shared/routes';

const CareManagementLocation = new Location({
  path: '/care-management'
});

export { CareManagementLocation };
